import {faCheck, faDownload, faEnvelope, faExternalLinkAlt, faMapMarkerAlt, faPhone} from '@fortawesome/free-solid-svg-icons';

export const icons = {
    mapMarker: faMapMarkerAlt,
    phone: faPhone,
    envelope: faEnvelope,
    download: faDownload,
    externalLink: faExternalLinkAlt,
    check: faCheck
};
